export const ActionTypes = {
    errorMessage: "ERROR_ALERT_MESSAGE",
    successMessage: "SUCCESS_ALERT_MESSAGE",
    clearMessage: "CLEAR_ALERT_MESSAGE"
}